import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";
import { capitalize } from "lodash";
import IconButton from "@shared/v2/IconButton";
import { BellRegularV6, PencilSolidV6, TrashCanSolidV6 } from "@shared/v2/Icomoon";
import {
  formattedPriceRange,
  formattedRange,
  formatLocationsForDisplay,
} from "../../../shared/ListingAlertHelpers";
import { alertDefaultProps, alertPropTypes, truncateText } from "./helper";
import CardDetailsView from "./CardDetailsView";
import AlertStatus from "./AlertStatus";

const ListingAlertCardView = ({
  alert,
  index,
  openEditListingAlertModal,
  openDeleteListingAlertModal,
  customClassName,
  websiteUrl,
}) => (
  <div
    key={alert.alertId}
    className={`tw-shadow-card tw-rounded-[6px] tw-p-[16px] tw-flex tw-flex-col ${customClassName}`}
  >
    <div className="tw-flex tw-justify-between tw-gap-[4px]">
      <div className="tw-flex tw-text-wrap [word-break:break-word]">
        <div className="tw-flex tw-items-center">
          <BellRegularV6 size="m" />
        </div>
        <a
          href={`https://${websiteUrl}/${alert.searchUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-flex tw-items-center tw-pl-[8px] tw-font-semibold !tw-text-[14px] tw-text-gray-75 tw-cursor-pointer"
        >
          {truncateText(alert.searchName, 35)}
        </a>
      </div>
      <div className="tw-flex tw-gap-4px">
        <IconButton size="small" schema="tertiary" onClick={() => openEditListingAlertModal(index)}>
          <PencilSolidV6 size="s" />
        </IconButton>
        <IconButton size="small" schema="tertiary" onClick={() => openDeleteListingAlertModal(index)}>
          <TrashCanSolidV6 size="s" />
        </IconButton>
      </div>
    </div>

    <div className="tw-pt-[12px] tw-flex tw-flex-col tw-gap-[8px] tw-overflow-y-scroll tw-max-h-[155px]">
      {alert.createdAt && (
        <CardDetailsView title="Created" value={dayjs(alert.createdAt).format("MM/D/YYYY")} />
      )}
      <div className="tw-flex tw-gap-[8px] tw-items-baseline">
        <AlertStatus alert={alert} />
      </div>
      {alert.active && <CardDetailsView title="Frequency" value={capitalize(alert.frequency)} />}
      <CardDetailsView title="Search Term" value={formatLocationsForDisplay(alert)} />
      <CardDetailsView title="Price" value={formattedPriceRange(alert.priceMin, alert.priceMax)} />
      <CardDetailsView title="Bed" value={formattedRange(alert.bedsMin, alert.bedsMax)} />
      <CardDetailsView title="Bath" value={formattedRange(alert.bathsMin, alert.bathsMax)} />
      <CardDetailsView title="Square Feet" value={formattedRange(alert.sqFtMin, alert.sqFtMax)} />
      <CardDetailsView title="Lot" value={formattedRange(alert.lotSizeMin, alert.lotSizeMax)} />
      <CardDetailsView title="Garage" value={formattedRange(alert.garageMin, alert.garageMax)} />
      <CardDetailsView title="Year" value={formattedRange(alert.yearMin, alert.yearMax)} />
    </div>
  </div>
);

ListingAlertCardView.propTypes = {
  alert: alertPropTypes,
  customClassName: PropTypes.string,
  index: PropTypes.number.isRequired,
  openEditListingAlertModal: PropTypes.func,
  openDeleteListingAlertModal: PropTypes.func,
  websiteUrl: PropTypes.string,
};
ListingAlertCardView.defaultProps = {
  alert: alertDefaultProps,
  openEditListingAlertModal: null,
  openDeleteListingAlertModal: null,
  customClassName: "",
  websiteUrl: "",
};

export default ListingAlertCardView;
